"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_ZONE = void 0;
var TIME_ZONE;
(function (TIME_ZONE) {
    TIME_ZONE["EASTERN"] = "America/New_York";
    TIME_ZONE["CENTRAL"] = "America/Chicago";
    TIME_ZONE["MOUNTAIN"] = "America/Denver";
    TIME_ZONE["PACIFIC"] = "America/Los_Angeles";
})(TIME_ZONE = exports.TIME_ZONE || (exports.TIME_ZONE = {}));
//# sourceMappingURL=timeZones.js.map